import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateGuildStats = (state: StatsSnapshot) => {
  const guild = state.generators.guild;

  const generatedThieves = guild.owned * guild.baseGeneration;

  stats.guild = {
    unitsGeneration: generatedThieves,
  };
};
